import React from 'react'
import NavBar from './Navbar';
import UserNavbar from './UserNavbar';
import Logo from './Logo';

import Languages from './Languages'
import Profileone from './Profileone';
import { USER_TYPE } from '../constants';

function Header() {
const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  
  return (
    <div style={{
    //  width:'1240px',
     minHeight: '70px',
      padding: '0px 10px',
      marginBottom: '15px',
      borderRadius: '5px',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      display:'flex', 
      alignItems:'center',
      zIndex: 9999,

      justifyContent:'space-between',   position: 'sticky',
      top: 0 }}>
      <Logo/>
      {userInfo && userInfo.userType === USER_TYPE.CLINICIAN ? <NavBar /> :  <UserNavbar /> }
      
      <div style={{display:'flex',alignItems:'center'}}>
        <Languages />
         <Profileone />
      </div>
    </div>
    

  )
}

export default Header